import { Card } from "../Card";
import { Skeleton } from "../Skeleton";

export const InterventionCardSkeleton = () => {
  return (
    <Skeleton.Group>
      <Card>
        <div className={"flex items-center justify-between"}>
          <div className={"flex items-center justify-center gap-3"}>
            <Skeleton.Skeleton>
              <h2 className="text-2xl">███████ ████ ███████</h2>
            </Skeleton.Skeleton>
          </div>
        </div>
        <div className={"pt-3"}>
          <Skeleton.Skeleton>
            <p className={"text-left text-sm leading-tight text-gray-200"}>
              ███████ ████ ███ █████ ████ ████ ███ ███
            </p>
          </Skeleton.Skeleton>
        </div>
      </Card>
    </Skeleton.Group>
  );
};
